<template>
  <div class="position-ab">
    <template v-if="show">
      <template v-if="isNoSillScore">
        <addSkiiScore
          :packId="packId"
          :type="0"
          ref="addSkiiScore"
        ></addSkiiScore>
      </template>
      <template v-else>
        <skiiScoreList ref="skiiScoreList"></skiiScoreList>
      </template>
    </template>
  </div>
</template>

<script>
import addSkiiScore from "@/app/sourcingFlow/views/expertEvaluate/addSkiiScore.vue";
import skiiScoreList from "@/app/sourcingFlow/views/expertEvaluate/skiiScoreList.vue";
import { qryExpertScorePackListApi } from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "skiiScore",
  components: {
    addSkiiScore,
    skiiScoreList
  },
  data() {
    return {
      show: false,
      isNoSillScore: false, // 是否是一个评分的都没有
      packId: "" // 一个评分都没有的时候，将第一个包件packId传入
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      qryExpertScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        scoreItem: "0"
      }).then(res => {
        // subPackageFlag: false 不分包
        if (res.data.data.subPackageFlag) {
          if (res.data.data.hasScorePack.length === 0) {
            this.isNoSillScore = true;
          }
          if (res.data.data.notScorePack.length !== 0) {
            try {
              // 看是否流标 packStatus 1正常5流标
              res.data.data.notScorePack.forEach(item => {
                if (item.packStatus == "1") {
                  this.packId = item.packId;
                  throw Error();
                }
              });
            } catch (e) {
              console.log(e);
            }
          }
        } else {
          // 不分包 scoreFlag：true 已评分
          if (res.data.data.scoreFlag) {
            this.isNoSillScore = false;
          } else {
            this.isNoSillScore = true;
          }
        }
        this.show = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.star {
  color: #ff1818;
}
.operate {
  height: 40px;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
</style>
